import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronDown, User, Settings } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "../../../supabase/auth";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useNavigate } from "react-router-dom";

export default function PublicNavbar() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 left-0 right-0 bg-agent-background/90 backdrop-blur-md border-b border-agent-border z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="font-bold text-2xl text-agent-primary">
              VOXI
            </Link>
            <nav className="hidden md:flex ml-10 space-x-8">
              <Link
                to="/"
                className="text-agent-text hover:text-agent-primary transition-colors py-2"
              >
                Home
              </Link>
              <Link
                to="/voice-agents"
                className="text-agent-text hover:text-agent-primary transition-colors py-2"
              >
                Voice AI
              </Link>
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <button className="text-agent-text hover:text-agent-primary transition-colors py-2 flex items-center">
                    Use Cases <ChevronDown className="ml-1 h-4 w-4" />
                  </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="bg-agent-card border-agent-border text-agent-text">
                  <DropdownMenuItem className="cursor-pointer hover:bg-agent-primary/10 hover:text-agent-primary">
                    <Link to="/use-cases/lead-qualification" className="w-full">
                      Lead Qualification
                    </Link>
                  </DropdownMenuItem>
                  <DropdownMenuItem className="cursor-pointer hover:bg-agent-primary/10 hover:text-agent-primary">
                    <Link to="/use-cases/customer-support" className="w-full">
                      Customer Support
                    </Link>
                  </DropdownMenuItem>
                  <DropdownMenuItem className="cursor-pointer hover:bg-agent-primary/10 hover:text-agent-primary">
                    <Link to="/use-cases/receptionists" className="w-full">
                      Receptionists
                    </Link>
                  </DropdownMenuItem>
                  <DropdownMenuItem className="cursor-pointer hover:bg-agent-primary/10 hover:text-agent-primary">
                    <Link to="/use-cases/dispatch-service" className="w-full">
                      Dispatch Service
                    </Link>
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
              <Link
                to="/assistants"
                className="text-agent-text hover:text-agent-primary transition-colors py-2"
              >
                Agents
              </Link>
              <Link
                to="/"
                className="text-agent-text hover:text-agent-primary transition-colors py-2"
              >
                Pricing
              </Link>
              <Link
                to="/"
                className="text-agent-text hover:text-agent-primary transition-colors py-2"
              >
                Docs
              </Link>
            </nav>
          </div>
          <div>
            {user ? (
              <div className="flex items-center space-x-4">
                <Link to="/dashboard">
                  <Button
                    variant="ghost"
                    className="text-agent-text hover:text-agent-primary hover:bg-agent-primary/10"
                  >
                    Dashboard
                  </Button>
                </Link>
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button
                      variant="ghost"
                      className="flex items-center space-x-2"
                    >
                      <Avatar className="h-8 w-8 border-2 border-agent-primary">
                        <AvatarImage
                          src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${user.email}`}
                          alt={user.email || ""}
                        />
                        <AvatarFallback className="bg-agent-card text-agent-primary">
                          {user.email?.[0].toUpperCase()}
                        </AvatarFallback>
                      </Avatar>
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent
                    align="end"
                    className="bg-agent-card border-agent-border text-agent-text"
                  >
                    <DropdownMenuItem className="cursor-pointer hover:bg-agent-primary/10 hover:text-agent-primary">
                      <User className="mr-2 h-4 w-4" />
                      Profile
                    </DropdownMenuItem>
                    <DropdownMenuItem
                      className="cursor-pointer hover:bg-agent-primary/10 hover:text-agent-primary"
                      onSelect={() => navigate("/organization-settings")}
                    >
                      <Settings className="mr-2 h-4 w-4" />
                      Settings
                    </DropdownMenuItem>
                    <DropdownMenuItem
                      className="cursor-pointer hover:bg-agent-primary/10 hover:text-agent-primary"
                      onSelect={() => signOut()}
                    >
                      Log out
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </div>
            ) : (
              <div className="flex items-center space-x-4">
                <Link to="/login">
                  <Button
                    variant="ghost"
                    className="text-agent-text hover:text-agent-primary hover:bg-agent-primary/10"
                  >
                    Sign In
                  </Button>
                </Link>
                <Link to="/signup">
                  <Button className="bg-agent-primary hover:bg-agent-primary/80 text-black font-medium">
                    Get Started
                  </Button>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
